<template>
    <div class="loader-container">
        <div class="loader"></div>
    </div>
</template>

<script>
export default {
    name: 'Spinner',
};
</script>
<style lang="scss">
@mixin keyframes($name) {
    @-webkit-keyframes #{$name} {
        @content;
    }
    @-moz-keyframes #{$name} {
        @content;
    }
    @-ms-keyframes #{$name} {
        @content;
    }
    @keyframes #{$name} {
        @content;
    }
}
.loader-container {
    display: flex;
    margin: 1rem;
    flex: 1;
    justify-content: center;
    align-items: center;
    .loader {
        border: 1rem solid #fafafa;
        border-top: 1rem solid #f0f0f0;
        border-radius: 50%;
        width: 7rem;
        height: 7rem;
        animation: spin 1s linear infinite;
        @include keyframes(spin) {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    }
}
</style>

